/** @file toPose3DError: recognises a thrown value (or its JSON copy) as a Pose3DError. */
import type { Pose3DError } from './pose3DError';

const optionalString = (v: unknown): boolean => v === undefined || typeof v === 'string';

function hasCoreFields(r: Record<string, unknown>): boolean {
  return r.name === 'Pose3DError' && typeof r.code === 'string' && typeof r.message === 'string';
}

function hasExtraFields(r: Record<string, unknown>): boolean {
  return typeof r.params === 'object' && r.params !== null && optionalString(r.path) && optionalString(r.hint);
}

/** The value itself typed as `Pose3DError` when it has that shape, otherwise null. */
export function toPose3DError(e: unknown): Pose3DError | null {
  if (typeof e !== 'object' || e === null) return null;
  const r = e as Record<string, unknown>;
  return hasCoreFields(r) && hasExtraFields(r) ? (e as Pose3DError) : null;
}
